module.exports = __webpack_public_path__ + "static/img/ios.c730aef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newSpark/ios.png
// module id = 1fRA
// module chunks = 12